import React, { createContext, useEffect, useReducer } from 'react';
import MatxLoading from "../../components/MatxLoading";
import axios from "./../../../axios";

const initialValue = {
    sales: []
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_SALE_DATA': {
            return {
                ...state,
                sales_list: action.payload,
            }
        }
        case 'UPDATE_SALE_DATA': {
            let newData = state.sales_list.sales.map((sale) =>
                action.payload.data.id === sale.id ? action.payload.data : sale
            );
            let newState = {
                sales: newData
            }

            return {
                ...state,
                sales_list: newState,
            }
        }
        case 'UPDATE_SALE_STATUS': {
            let newData = state.sales_list.sales.map((pro) =>
                action.payload.id === pro.id ? action.payload : pro
            );
            let newState = {
                sales: newData
            }
            return {
                ...state,
                sales_list: newState,
            }
        }
        default: {
            return state
        }
    }
}

const SaleContext = createContext({
    sales_list: initialValue,
    getSales: () => {},
    getSale: () => {},
    addSale: () => {},
    updateSale: () => {},
    addToSale: () => {},
    changeSalesStatus: () => {},
})

export const SalesProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)

    const getSales = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/get_sales', options);

            dispatch({
                type: 'LOAD_SALE_DATA',
                payload: res.data,
            });
            
        } catch (e) {
            console.error(e)
        }
    }

    const getSale = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/get_sale/'+id, options);

            return res.data;
        } catch (e) {
            console.error(e)
            return null;
        }
    }


    const addSale = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/sales/add_sale', data, options);

            return res;
        } catch (e) {
            console.error(e)
            return e;
        }
    }

    const updateSale = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/sales/update_sale', data, options);

            return res;
        } catch (e) {
            console.error(e)
            return e;
        }
    }

    const addToSale = async (product_id, sale_id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.get('/api/sales/add_to_sale/'+product_id+"/"+sale_id, options);

            return res;
        } catch (e) {
            console.error(e)
            return e;
        }
    }

    const changeSalesStatus = async (sale_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/sales/change_sale_status/${sale_id}/${status}`, options);

            dispatch({
                type: 'UPDATE_SALE_STATUS',
                payload: res.data
            })
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getSales();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.sales_list === undefined) {
        return <MatxLoading />
    }

    return (
        <SaleContext.Provider
            value={{
                sales_list: state.sales_list,
                getSales,
                getSale,
                addSale,
                updateSale,
                addToSale,
                changeSalesStatus,
            }}
        >
            {children}
        </SaleContext.Provider>
    )
}

export default SaleContext
